// CTV-800: the Studio's WaymarkTransport.
//
// The staff Studio talks to the authenticated super_admin endpoints, keyed on
// the commercial's ROW ID, rather than the public ones keyed on its access
// token. The row's access_token is never sent to the browser at all: it exists
// only because the column is NOT NULL.
//
// This is the whole difference between the Studio and the buyer surfaces at
// the SDK layer. Everything else (the provider, the editor sessions, the
// arbiter) is shared.

import { apiClient } from '../../../lib/apiClient';
import type { IssueTokenResponse, WaymarkTransport } from './types';

/**
 * The reserved sentinel station slug every studio commercial carries. Matches
 * no station, so credential resolution falls through to CTVBuyer's own
 * Waymark partner. Mirrors STUDIO_STATION_SLUG in
 * selfservice-api/src/modules/waymark/waymark-studio.service.ts and the entry
 * in RESERVED_STATION_SLUGS, which is the actual gate.
 */
export const STUDIO_SLUG = 'studio';

export function studioTransport(commercialId: string): WaymarkTransport {
  return {
    issueToken: ({ forceCreate }) =>
      apiClient.post<IssueTokenResponse>(
        `/admin/waymark/commercials/${commercialId}/token`,
        forceCreate ? { forceCreate: true } : {},
      ),
    persistState: async (body) => {
      await apiClient.post(`/admin/waymark/commercials/${commercialId}/state`, body);
    },
  };
}
